export default __webpack_public_path__ + "static/media/logo.358ea406.png";